"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const youtube_video_1 = __importDefault(require("../youtube-video"));
const utils_1 = __importDefault(require("./utils"));
const Image_1 = __importDefault(require("./Image"));
const Media = (props) => {
    if ((0, utils_1.default)(props)) {
        return (0, jsx_runtime_1.jsx)(youtube_video_1.default, { ...props });
    }
    return (0, jsx_runtime_1.jsx)(Image_1.default, { ...props });
};
exports.default = Media;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVkaWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbWVkaWEvTWVkaWEudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHFFQUE0QztBQUM1QyxvREFBbUM7QUFFbkMsb0RBQTRCO0FBRTVCLE1BQU0sS0FBSyxHQUFHLENBQUMsS0FBWSxFQUFFLEVBQUU7SUFDN0IsSUFBSSxJQUFBLGVBQVksRUFBQyxLQUFLLENBQUMsRUFBRSxDQUFDO1FBQ3hCLE9BQU8sdUJBQUMsdUJBQVksT0FBSyxLQUFLLEdBQUksQ0FBQztJQUNyQyxDQUFDO0lBRUQsT0FBTyx1QkFBQyxlQUFLLE9BQUssS0FBSyxHQUFJLENBQUM7QUFDOUIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsS0FBSyxDQUFDIn0=